import { Link } from "react-router-dom";
import ImageSlider from "./common/ImageSlider";
import ProjectInfo from "./project-details/ProjectInfo";
import { useTranslation } from "react-i18next";

const Aseat = () => {
  const { t } = useTranslation();

  const images = [
    "assets/img/portfolio/aseat.png",
    "assets/img/portfolio/aseat2.png",
    "assets/img/portfolio/aseat3.png",
  ];
  const projectData = {
    title: "Aseat",
    stack: "Wordpress",
    projectUrl: "https://www.aseat.co.za",
    description: "aseatDesc",
  };

  return (
    <>
      <main id="main">
        <section className="portfolio-details">
          <div className="container">
            <div className="row gy-4">
              <ImageSlider images={images} />

              <div className="col-lg-4">
                <ProjectInfo
                  stack={projectData.stack}
                  projectUrl={projectData.projectUrl}
                />

                <div className="portfolio-description">
                  <h2>Description</h2>
                  <p>
                    {t("aseatDesc")}
                    <br />
                    <strong>{t("Key Features")}:</strong>{" "}
                    <em>{t("aseatFeatures")}</em>
                    .<br />
                    {t("aseatFeatures2")}
                  </p>
                </div>
                <Link to="/work">
                  <i class="bi bi-arrow-left"></i>
                  {t("Back")}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Aseat;
